import { fromJS as ImmutableFromJs } from 'immutable';
import AltInstance from '../Globals/Scripts/AltInstance';
import ProfileActions from '../Actions/ProfileActions';
import { setupGoogleTagManagerScript } from '../Globals/Scripts/GoogleTagManagerSetup';
import { rg4js } from '../Globals/Scripts/RaygunSetup';
import Configuration from '../Globals/Scripts/Configuration';
import { Profile } from './Types/Types';

class ProfileStore {
    profile: Profile;

    constructor() {
        // Disabling 'no explicit any' rule justification.
        //   Without casting to the special type 'any' the 'bindActions' line errors with 'Property BindActions does not exist on type ProfileStore'.
        //   Could not find a way to strongly type the call to 'bindActions' using the defined types in ../../ThirdParty/Alt/typings/alt/alt.d.ts.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).bindActions(ProfileActions);
        this.profile = ImmutableFromJs(Configuration.defaultProfile);
    }

    onProfileLoaded(profile: Profile) {
        this.profile = ImmutableFromJs(profile);
        const user = this.profile.get('user');
        setupGoogleTagManagerScript(user?.get('userResourceId') as string);

        rg4js('setUser', {
            identifier: user?.get('userResourceId') as string,  // identifier is a required property whereas the rest are optional.
            isAnonymous: false,
            email: user?.get('username'),
            firstName: user?.get('name'),
            fullName: user?.get('fullName')
        });
    }
}

export default AltInstance.createStore(ProfileStore, 'ProfileStore');
